<template>
  <div class="p_pk10">
    <v-p-top @showResult="onShowResult"
             @end="handle_end"
             :phase="phase"
             :next_phase="next_phase"
             :records="records"
             :name="head.title"
             :remain_time="remain_time"
             :block_time="block_time"
             @change="changeFp"
    >
      <ul slot="recodeNumber" class="num_record">
        <li v-for="(num, index) in records" :key="'re' + index" class="item" :class="'number2' + num"></li>
      </ul>
    </v-p-top>

    <template v-if="!$route.query.notice">
      <v-tab class="page-tabs" v-if="tabs.length" :current="tabs[curTab].value" @onChangeTab="onTabChanged" :tabs="tabs"
             :border="true"></v-tab>

      <div class="pk10-main page-wrapper" :style="contentStyleObj">

        <v-c-input @again="handle_again" class="c-input" v-model="chip" @certain="certain_handle"
                   @reset="reset_selected" />

        <!-- inner-tab -->
        <component :chip="chip.toString()" ref="c_model_input" :is="componentsName" class="component-page"
                   :data="tabPageData"></component>
        <!-- inner-tab end -->

        <v-c-input @again="handle_again" class="c-input" v-model="chip" @certain="certain_handle"
                   @reset="reset_selected" />

        <v-statistic @showRule="onShowRule" class="page-side"></v-statistic>

      </div>
      <order ref="order" @submit="order_sub" :orders="orders"/>
    </template>
    <template>
      <div class="listen">
        <audio controls="controls" hidden id="audio1">
          <source src="../../../assets/1.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio2">
          <source src="../../../assets/2.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio3">
          <source src="../../../assets/3.mp3" type="audio/mpeg"/>
        </audio>
      </div>
    </template>
  </div>
</template>

<script>
  import methods from '../methods';
  import {mapState, mapActions} from 'vuex';
  import Order from '../../../components/dialog/order';
  import VPTop from '../../../components/c_top';
  import VSelect from '../../../components/c_select';
  import VStatistic from '../../../components/c_statistics';
  import VTab from '../../../components/c_tab';
  import VCInput from '../../../components/c_a-input';
  import DH110 from '../../../components/pageComponents/pk10/dh1-10';
  import LMP from '../../../components/pageComponents/pk10/lmp';
  import GYH from '../../../components/pageComponents/pk10/gyh';
  import GYZH from '../../../components/pageComponents/pk10/gyzh';
  import eventMixin from '../../../utils/eventMixin';
  import {computedDataPK10} from '../../../utils/computed';

  const each = (cb, el) => {
    (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
    if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
  };

  export default {
    name: "PK10",
    mixins: [eventMixin, methods],
    components: {
      Order,
      VTab,
      VPTop,
      VSelect,
      VCInput,
      VStatistic,
      DH110,
      LMP,
      GYH,
      GYZH
    },
    computed: {
      // 封盘倒计时
      remain_time() {
        return this.lottery.next_info.remain_time;
      },
      block_time() {
        return this.lottery.next_info.block_time;
      },
      next_phase() {
        return this.lottery.next_info.period;
      },
      // 期数
      phase() {
        return this.lottery.latest_result.period;
      },
      // 开奖号码
      records() {
        return this.lottery.latest_result.number ? this.lottery.latest_result.number.split(',') : [];
      },
      ...mapState({
        curTab: state => state.home_PK10.curTab,
        headTabs: state => state.home.headTabs,
        tabs: state => state.home_PK10.tabs,
        odds: state => state.home_PK10.odds,
        lottery: state => state.home_PK10.lottery,
        order_history: state => state.home_PK10.order_history,
        longQueue: state => state.home.longQueue,
        statistics: state => state.home.statistics
      }),
      current() {
        return this.tabs[this.curTab] || null;
      },
      head() {
        return this.headTabs.find(item => item.lottery_type == this.$route.query.lottery_type) || {};
      },
      componentsName() {
        let _name = 'l-m-p';
        switch (this.curTab) {
          case 1:
            _name = 'd-h110';
            break;
          case 2:
            _name = 'g-y-h';
            break;
          case 3:
            _name = 'g-y-z-h';
            break;
        }
        return _name;
      },
      tabPageData() {
        const odds = this.odds.map(item => {
          if (!item._status) item._status = item.status;
          if (!this.time) {
            item.status = 3;
          } else if (item.status === 3) {
            item.status = item._status;
          }
          return item;
        });

        return computedDataPK10(odds, this.current, this.curInnerTab);
      }
    },
    data() {
      return {
        origin_list: null,
        // 最后选择的订单号
        orders: [],
        order_subing: false,

        // 连码选择
        curInnerTab: 0,
        // 筹码
        chip: '',

        // 封盘&&倒计时
        time: 0,
        contentStyleObj: {
          height: ''
        },
      }
    },
    methods: {
      ...mapActions({
        createOrder: 'home_PK10/createOrder',
        getNewLotteryRes: 'home_PK10/getNewLotteryRes',
        updateUserInfo: 'root/updateUserInfo',
        getLotteryLatest: 'home/getLotteryLatest',
        getLongQueue: 'home/getLongQueue',
        getStatistics: 'home/getStatistics'
      }),
      onRest() {
        for (let i in this.tabPageData) {
          this.tabPageData[i].map(lists => {
            lists.list.map(item => item.selected = false);
          });
        }
      },
      getHeight() {
        this.contentStyleObj.height = window.innerHeight - 220 + 'px';
      },
    },
    created() {
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          if (lett.$refs.order.showOrderDialog === true) {
            lett.$refs.order.handle_submit();
          } else {
            lett.certain_handle();
          }
        }
      }

      window.addEventListener('resize', this.getHeight);
      this.getHeight();
    },

  }
</script>

<style scoped lang="stylus">
  .p_pk10
    .s_game-center
      margin-top 4px
      background-color #ffffff
</style>



// WEBPACK FOOTER //
// src/pages/home/PK10/index.vue